<template>
  <Container class="flex-col align-start">
    <h2 style="padding:5px 0;margin:10px 20px;border-bottom:3px solid var(--border);">应付账龄分析</h2>
    <div class="flex-wrap" style="margin:0 20px 10px;gap:10px;align-items:center;">
      <Input search clearable placeholder="供应商 / 合同关键字" style="width:220px;" />
      <Select placeholder="账龄区间" transfer style="width:160px;" clearable />
      <DatePicker type="daterange" placeholder="应付到期日" transfer style="width:240px;" />
      <Button type="primary" icon="ios-search">查询</Button>
      <Button icon="md-download">导出</Button>
    </div>
    <div style="padding:0 20px;height:calc(100% - 120px);width:100%;position:relative;">
      <BaseTable ref="table" :columns="cols" :data="items" full />
    </div>
  </Container>
</template>

<script>
import Container from '@/components/app/container';

export default {
  routerOption: {},
  components: { Container },
  data() {
    return {
      items: [],
      cols: [
        { title: '序号', width: 60, type: 'index' },
        { title: '供应商', minWidth: 160, key: 'vendor' },
        { title: '合同 / 订单', minWidth: 200, key: 'contract' },
        { title: '应付余额(元)', width: 130, key: 'balance' },
        { title: '0–30天', width: 100, key: 'b0_30' },
        { title: '31–60天', width: 100, key: 'b31_60' },
        { title: '61–90天', width: 100, key: 'b61_90' },
        { title: '90天以上', width: 110, key: 'b90p' },
        { title: '最近到期日', width: 120, key: 'due_date' },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.table && this.$refs.table.calcTableHeight) {
        setTimeout(() => this.$refs.table.calcTableHeight(), 300);
      }
    });
  },
};
</script>

<style lang="less" scoped>
</style>
